import axios from 'axios'
import { message } from 'ant-design-vue'
import store from '@/store/index'
import { getToken } from '@/utils/auth'
// 业务请求接口 前缀
// export const base_url = `http://192.168.8.110:8700` //罗超
// export const base_url = `http://172.168.111.48:8700`;
// export const base_url = `http://192.168.9.16:8700`;
// export const base_url = `http://192.168.8.109:8700` //柏在超
// export const base_url = `http://localhost:8700`;
// export const base_url = `https://wx.jk-hs.com`;
export const base_url = `https://hnzhyl.net`
// export const base_url = 'https://hn.szdszhyl.com'
// export const base_url = `http://172.16.11.95:8700`
// export const base_url = `http://10.10.101.226:8700`
const service = axios.create({
  baseURL: base_url,
  timeout: 60000 // request timeout
})
service.interceptors.request.use(
  (config) => {
    let token = getToken()
    if (token) {
      config.headers['token'] = token
    }
    if (!store.state.payStatus) {
      store.commit('showLoading')
    }
    if (process.env.NODE_ENV === 'development') {
      console.log('请求参数', config)
    }
    return config
  },
  (error) => {
    message.error(error)
    store.commit('hideLoading')

    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  (response) => {
    store.commit('hideLoading')
    const res = response.data
    if (res.code !== 200 && res.code !== 208 && res.code !== 3002 && res.code !== 3001 && res.code !== 500 && res.code !== 100 && res.code !== 40001) {
      if (response.config.url.indexOf('/api/order/getAlipayStatus/') < 0) message.error(res.message)
    }
    if (process.env.NODE_ENV === 'development') {
      console.log('请求结果', res)
    }
    return res
  },
  (error) => {
    message.error('error')
    store.commit('hideLoading')
    // console.log('err' + error) // for debug

    return Promise.reject(error)
  }
)

export default service
